import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';

import { AuthService } from './services/auth.service';
import { APIHelperService } from './services/api-helper.service';
import { ErrorInterceptor  } from '../shared/components/interceptors/error.interceptor';
import { JwtInterceptor  } from '../shared/components/interceptors/jwt.interceptor';
import { SkeletonLoaderComponent } from './components/skeleton-loader/skeleton-loader.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { SiblingSwitcherComponent } from './components/sibling-switcher/sibling-switcher.component';


@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        IonicModule,
    ],
    providers: [
        AuthService,
        APIHelperService,
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
      ],
    declarations: [
        SkeletonLoaderComponent,
        EmptyStateComponent,
        SiblingSwitcherComponent,
    ],
    exports: [
        HttpClientModule,
        FormsModule,
        CommonModule,
        IonicModule,
        SkeletonLoaderComponent,
        EmptyStateComponent,
        SiblingSwitcherComponent,
    ]

})
export class SharedModule { }